<script>
import vueSlider from 'vue-slider-component';
import Vue from 'vue';
export default Vue.extend({
  components: { vueSlider },
  props: { value: Number, default: null, whiteMode: { type: Boolean } },
  data() {
    return { 
      sValue: this.value ?? 0,
      isInitialized: false,
      hasScore: this.value !== null && this.value !== undefined,
      accessibleHandle: null,
      animationTimeouts: []
    };
  },
  methods: {
    check(score) {
      if (!this.isInitialized) return;
      this.sValue = score;
      this.hasScore = true;
      this.updateAccessibleValue();
      this.$emit('input', score);
    },
    configureAccessibleHandle() {
      const slider = this.$refs.Slider;
      const root = slider && slider.$el;
      this.accessibleHandle = root && root.querySelector('.vue-slider-dot');
      if (!this.accessibleHandle) return;
      const track = root.querySelector('.vue-slider');
      if (track) track.removeAttribute('aria-hidden');
      // O vue-slider tem um <input type="range"> escondido dentro do trilho; sem o aria-hidden do trilho,
      // ele viraria um segundo slider sem nome no Tab. O slider acessível é só a bolinha.
      const nativeRange = root.querySelector('.vue-slider-sr-only');
      if (nativeRange) {
        nativeRange.setAttribute('tabindex', '-1');
        nativeRange.setAttribute('aria-hidden', 'true');
      }
      this.accessibleHandle.setAttribute('role', 'slider');
      this.accessibleHandle.setAttribute('tabindex', '0');
      this.accessibleHandle.setAttribute('aria-labelledby', 'introText');
      this.accessibleHandle.setAttribute('aria-valuemin', '0');
      this.accessibleHandle.setAttribute('aria-valuemax', '10');
      this.accessibleHandle.addEventListener('keydown', this.handleSliderKeydown);
      this.updateAccessibleValue();
    },
    updateAccessibleValue() {
      if (!this.accessibleHandle) return;
      this.accessibleHandle.setAttribute('aria-valuenow', String(this.sValue));
      // Sem nota escolhida, a bolinha fica no 0: o leitor anunciaria "0" como se fosse a nota.
      if (this.hasScore) this.accessibleHandle.removeAttribute('aria-valuetext');
      else this.accessibleHandle.setAttribute('aria-valuetext', this.$t('generic.noScore'));
    },
    handleSliderKeydown(event) {
      let nextValue = this.sValue;
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') nextValue += 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') nextValue -= 1;
      else if (event.key === 'Home') nextValue = 0;
      else if (event.key === 'End') nextValue = 10;
      else return;

      event.preventDefault();
      nextValue = Math.max(0, Math.min(10, nextValue));
      // Sem nota escolhida, a primeira tecla já escolhe, mesmo sem mudar o valor (Home/← no 0).
      if (nextValue !== this.sValue || !this.hasScore) {
        this.onDragStart();
        this.check(nextValue);
      }
    },
    onDragStart() {
      this.isInitialized = true;
      this.animationTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
      this.animationTimeouts = [];
    },
  },
  mounted: function () {
    this.$nextTick(this.configureAccessibleHandle);
    window.addEventListener('resize', () => {
      setTimeout(() => {
        if (this.$refs.Slider) this.$refs.Slider.refresh();
      }, 400);
    });

    if (this.value === null) {
      this.animationTimeouts = [
        setTimeout(() => {
          this.sValue = 10;
        }, 1000),
        setTimeout(() => {
          this.sValue = 0;
        }, 1500),
        setTimeout(() => {
          this.sValue = 0;
          this.isInitialized = true;
        }, 1510)
      ];
    } else {
      this.isInitialized = true;
    }
  },
  beforeDestroy() {
    if (this.accessibleHandle) {
      this.accessibleHandle.removeEventListener('keydown', this.handleSliderKeydown);
    }
  },
});
</script>

<template>
  <div class="sliderNPS" :class="{ 'slider-dark': whiteMode }">
    <vue-slider
      class="mx-auto"
      style="max-width: 460px"
      ref="Slider"
      :initial-animation="true"
      :min="0"
      :max="10"
      :dotSize="30"
      :height="10"
      :tooltip="'never'"
      :lazy="false"
      :piecewiseLabel="true"
      :labelStyle="{ color: 'white', fontSize: '25px' }"
      :bgStyle="{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }"
      :processStyle="{ backgroundColor: '#FFF' }"
      :value="sValue"
      @callback="check"
      @drag-start="onDragStart"
    >
      <template slot="dot">
        <div class="vue-slider-never vue-slider-dot" style="width: 30px; height: 30px">
          <div class="vue-slider-dot-handle bg-accent" style="border: 3px solid white"></div>
        </div>
      </template>
    </vue-slider>
  </div>
</template>
<style>
.sliderNPS .vue-slider-piecewise-item:not(:first-child):not(:last-child) {
  display: none;
}
.slider-dark .vue-slider-piecewise-label {
  color: #343a40 !important;
}
.slider-dark .vue-slider-process {
  background-color: #343a40 !important;
}
.slider-dark .vue-slider {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
.vue-slider-dot[role='slider']:focus-visible {
  outline: 3px solid currentColor;
  outline-offset: 4px;
}
@media (max-width: 900px) {
  .sliderNPS {
    margin-top: -10px !important;
  }
  .big-number {
    margin-top: -10px !important;
  }
  .arrowSurvey .survey-card .secondary {
    margin-top: -35px;
  }
  .arrowSurvey .vue-slider-component {
    margin-top: -10px;
  }
}
@media (max-width: 767px) {
  .sliderNPS {
    margin-bottom: 10px !important;
  }
}
</style>
